import { parse } from 'date-fns';
import { DATE_TIME_FORMAT } from '../../../../constants';
import { ReportSettingFiscalRollforwardState } from '../FiscalRollforward';

export const getReportEndDateFiscalRollforward = (
  reportSettingState: ReportSettingFiscalRollforwardState,
): Date => {
  const { rollforwardThrough } = reportSettingState;
  return parse(rollforwardThrough, DATE_TIME_FORMAT.FULL_DATE, new Date());
};
